<app-collapsible-container
    [id]="'address'"
    [title]="'REPERTOIRE.FORMS.ADDRESS.TITLE'"
    [icon]="'i-home'"
    (elementSizeModification)="elementSizeModification.emit()"
>
    <app-address
        [formControl]="control"
        [entityType]="entityType"
        (elementSizeModification)="elementSizeModification.emit()"
        [readOnly]="readonly"
    ></app-address>
</app-collapsible-container>
